export default "__VITE_ASSET__BpENy37H__"